import { ListAction } from "../../helpers/enums";

export class ListEventArgs {
  constructor(public sender: ListAction, public model?: any) {}
}
